import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { MessageHOC, ApiHOC } from '../../../shared';
import { FinancialYearSelector } from './FinancialYearSelector';
import { setSalesYear } from './store/action';
import { getSelectedSalesYear } from './store/selectors';
import { GET_CURRENT_CROP_SALES_YEAR } from '../../../constants/ApiConstants';

const mapStateToProps = (state, ownProps) => {
  return {
    messages: ownProps.commonMessages,
    salesYear: getSelectedSalesYear(state),
    getSeasonCropYearFromConfig: (onComplete, onError) => {
      ownProps.GET(
        GET_CURRENT_CROP_SALES_YEAR,
        (response) => onComplete(response['crop_season_start_year']),
        onError
      );
    },
  };
};

const mapDispatchToProps = (dispatch) => {
  const updateSalesYear = (salesYear) => {
    dispatch(setSalesYear(salesYear));
  };

  return {
    updateSalesYear: updateSalesYear,
  };
};

export default ApiHOC()(
  MessageHOC()(
    withRouter(
      connect(mapStateToProps, mapDispatchToProps)(FinancialYearSelector)
    )
  )
);
